import { useLocation } from "react-router-dom";
import Footer from "./components/footer";
import Header from "./components/header";
import "./style.scss";
import { useEffect, useState } from "react";
import SEO from "components/SEO";
import GoPremiumCard from "components/CustomWidgets/goPremiumCard";
import GoPremiumModal from "components/CustomWidgets/goPremiumModal";

function Layout(props) {
  const { children, isFooter = true, isLanding } = props;
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  // scroll to top
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <>
      <SEO />
      <div
        className={`layout-wrapper ${isLanding ? "landing" : "default-page"}`}
      >
        {!isLanding && <div className="bg-svg-image" aria-hidden="true"></div>}
        <Header
          isLanding={isLanding}
          showPremiumModal={showPremiumModal}
          setShowPremiumModal={setShowPremiumModal}
        />
        {showPremiumModal && (
          <GoPremiumModal
            open={showPremiumModal}
            wrapClassName={`go-premium-primary`}
            contentTitle="Upgrade to send messages"
            buttonTitle="Upgrade plan"
            onCancel={() => {
              setShowPremiumModal(false);
            }}
            onOk={() => {
              setShowPremiumModal(false);
            }}
          />
        )}
        <main>{children}</main>
        {isFooter && <Footer />}
      </div>
    </>
  );
}

export default Layout;
